export class UserType {
    public id: string;
    public name: string;
    public permissions: string[];
    public category: string;
    public rank: number;
    public group: UserTypeGroup;
    public restrictDataAccess: boolean;
}

export enum UserTypeCategory {
    CUSTOMER = 'CUSTOMER',
    ORGANIZATION = 'ORGANIZATION',
    PARTNER = 'PARTNER'
}

export enum UserTypeGroup {
    BACK_OFFICE = 'BACK_OFFICE',
    SERVICE = 'SERVICE',
    CUSTOMER = 'CUSTOMER',
    DATA_RECIPIENT = 'DATA_RECIPIENT'
}